import { contract } from "../stores/index"
import { navigate } from "svelte-routing"

export function navigateCustom(url) {
  let currentContract
  contract.subscribe((contract) => {
    currentContract = contract.id
  })

  return navigate(`/access-manager/contracts/${currentContract}${url}`)
}
